<template>
  <div class="wrap">
    <div class="left"></div>
    <div class="right">
      <div class="loginBox">
        <div class="logo"><img src="@/assets/image/logo.png" alt=""></div>
        <div class="username">
          <span class="name">账号</span><span class="nameEnglish">Sign in</span>
          <div class="int">
            <el-input v-model="loginForm.email" placeholder="请输入电子邮箱" prefix-icon="el-icon-message"
              clearable></el-input>
          </div>
        </div>
        <div class="username">
          <span class="name">密码</span><span class="nameEnglish">password</span>
          <div class="int">
            <el-input v-model="loginForm.password" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password
              clearable @keyup.enter.native="handleLogin"></el-input>
          </div>
        </div>
        <div class="btn">
          <el-button class="buttint" :loading="loading" @click="handleLogin">登录</el-button>
        </div>
        <div class="check">
          <div><el-checkbox v-model="loginForm.rememberMe">下次自动登录</el-checkbox></div>
          <div class="forget" @click="goForget">忘记密码?</div>
        </div>

        <div class="register">
          <div class="line"></div>
          <div class="name" @click="goRegister">立即注册</div>
          <div class="line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    encrypt
  } from '@/utils/jsencrypt'
  import {
    login
  } from '@/api/user'

  export default {
    name: "Login",
    data() {
      return {
        loginForm: {
          email: "",
          password: "",
          rememberMe: false
        },
        loading: false,
        redirect: undefined
      }
    },
    watch: {
      $route: {
        handler: function(route) {
          this.redirect = route.query && route.query.redirect
        },
        immediate: true
      }
    },
    created() {
      // 从cookie获取记住的邮箱
      this.loginForm.email = this.$cookies.get('email') || ''
      if (this.loginForm.email) {
        this.loginForm.rememberMe = true
      }
    },
    methods: {
      goForget() {
        this.$router.push("/Forget")
      },
      goRegister() {
        this.$router.push("/register")
      },
      async handleLogin() {
        // 表单验证
        if (!this.loginForm.email || !this.loginForm.password) {
          this.$modal.msgError("请输入电子邮箱和密码")
          return
        }
        if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.loginForm.email)) {
          this.$modal.msgError("邮箱格式不正确")
          return
        }

        this.loading = true

        // 记住邮箱
        if (this.loginForm.rememberMe) {
          this.$cookies.set('email', this.loginForm.email, {
            expires: 7
          })
        } else {
          this.$cookies.remove('email')
        }

        try {
          // 调用邮箱登录接口
          const res = await emailLogin({
            email: this.loginForm.email,
            password: this.loginForm.password // 密码将在后端加密验证
          })

          // 登录成功处理
          this.$store.dispatch('user/login', res.data).then(() => {
            this.$modal.msgSuccess("登录成功")
            this.$router.push(this.redirect || '/')
          })
        } catch (error) {
          this.$modal.msgError(error.message || "登录失败")
        } finally {
          this.loading = false
        }
      }
      // // 调用登录接口
      // login(loginData).then(res => {
      //   // 登录成功处理
      //   this.$store.dispatch('user/login', loginData).then(() => {
      //     this.$modal.msgSuccess("登录成功")
      //     // 跳转到首页或redirect页面
      //     this.$router.push({
      //       path: this.redirect || '/'
      //     })
      //   }).catch(() => {
      //     this.loading = false
      //   })
      // }).catch(() => {
      //   this.loading = false
      // })

    }
  }
</script>

<style scoped lang="scss">
  .wrap {
    width: 100%;
    display: flex;

    .left {
      width: 60%;
      height: 100vh;
      background: url('../../assets/image/leftImg.png') no-repeat;
      background-position: center;
      background-size: cover;
    }

    .right {
      width: 40%;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;

      .loginBox {
        width: 40%;
        height: 50vh;

        .logo {
          width: 100%;
          padding: 30px 0;
          display: flex;
          justify-content: center;
        }

        .username {
          text-align: left;
          width: 100%;

          .name {
            font-weight: bold;
          }

          .nameEnglish {
            padding-left: 20px;
            font-size: 14px;
          }

          .int {
            padding: 10px 0;
          }
        }

        .btnbox {}

        .btn {
          width: 100%;
          padding: 30px 0;

          .buttint {
            width: 100%;
            background-color: #25877d;
            color: #ffffff;
          }
        }

        .check {
          width: 100%;
          display: flex;
          justify-content: space-between;

          .forget {
            font-size: 14px;
            cursor: pointer;
          }
        }

        .register {
          width: 100%;
          height: 60px;
          align-items: center;
          display: flex;

          .line {
            width: 25%;
            height: 6px;
            background-color: #25877d;
          }

          .name {
            width: 50%;
            text-align: center;
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Login/index.vue